// src/pages/Support/components/FilterBar.js

import React from "react";
import { Input, Select, Button, Flex, DatePicker } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";

const { Option } = Select;
const { RangePicker } = DatePicker;

const FilterBar = ({ filters, onFilterChange }) => {
  // Filter options (matching BE enum values)
  const filterOptions = {
    priorities: [
      { value: "", label: "All Priorities" },
      { value: "critical", label: "Critical" },
      { value: "high", label: "High" },
      { value: "medium", label: "Medium" },
      { value: "low", label: "Low" },
    ],
    statuses: [
      { value: "", label: "All Status" },
      { value: "opened", label: "Opened" },
      { value: "in_progress", label: "In Progress" },
      { value: "resolved", label: "Resolved" },
      { value: "closed", label: "Closed" },
    ],
  };

  // Handle date range change
  const handleDateChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      onFilterChange("fromDate", dates[0].format("YYYY-MM-DD"));
      onFilterChange("toDate", dates[1].format("YYYY-MM-DD"));
    } else {
      onFilterChange("fromDate", "");
      onFilterChange("toDate", "");
    }
  };

  return (
    <div style={{ padding: "20px 0" }}>
      <Flex wrap="wrap" gap={12} align="center">
        {/* Search Input */}
        <Input
          placeholder="Search by Ticket ID or Subject"
          suffix={
            <img
              src="/search-normal.png"
              alt="search"
              style={{
                width: 16,
                height: 16,
                objectFit: "contain",
                opacity: 0.6,
              }}
            />
          }
          value={filters.search}
          onChange={(e) => onFilterChange("search", e.target.value)}
          allowClear
          style={{
            flex: "0 0 350px",
            width: 350,
          }}
        />

        {/* Status Filter */}
        <Select
          value={filters.status}
          onChange={(value) => onFilterChange("status", value)}
          style={{
            flex: "0 0 180px",
            width: 180,
          }}>
          {filterOptions.statuses.map((opt) => (
            <Option key={opt.value} value={opt.value}>
              {opt.label}
            </Option>
          ))}
        </Select>

        {/* Date Range Picker */}
        <RangePicker
          onChange={handleDateChange}
          format="YYYY-MM-DD"
          placeholder={["From Date", "To Date"]}
          style={{
            flex: "0 0 260px",
            width: 260,
          }}
        />
      </Flex>
    </div>
  );
};

export default FilterBar;
